<template>
  <v-card v-if="isShow">
    <v-snackbar
      v-model="isShow"
      :color="color"
      top
      auto-height
      :multi-line="true"
      :timeout="timeout"
      key="global-message"
    >
      {{ text }}
      <v-btn dark flat @click="isShow = false">Close</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      y: "top",
      text: "",
      timeout: 10000,
      color: ""
    };
  },
  methods: {
    /**
     * メッセージをsnackbarに設定する
     */
    setMessage(message) {
      this.isShow = true;
      this.text = message;
      this.color = "error";
    }
  }
};
</script>

<style scoped></style>
